import { useState, useEffect } from "react";
import SectionCard from "../components/SectionCard";

export default function Step1({ data, onChange, onNext }) {

  // Máscara de telefone
  function maskPhone(v) {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
    v = v.replace(/(\d{5})(\d)/, "$1-$2");
    return v.slice(0, 15);
  }

  // Máscara de CPF
  function maskCPF(v) {
    v = v.replace(/\D/g, "");
    v = v.slice(0, 11);

    if (v.length > 9)
      return v.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");

    if (v.length > 6)
      return v.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");

    if (v.length > 3)
      return v.replace(/(\d{3})(\d{1,3})/, "$1.$2");

    return v;
  }

  // ✅ Máscara de data automática DD/MM/AAAA
  function maskDate(v) {
    v = v.replace(/\D/g, "");
    v = v.slice(0, 8);

    if (v.length >= 5)
      return v.replace(/(\d{2})(\d{2})(\d+)/, "$1/$2/$3");

    if (v.length >= 3)
      return v.replace(/(\d{2})(\d+)/, "$1/$2");

    return v;
  }

  // ✅ Validação de data + maior de 18 anos
  function validarNascimento(data) {
    if (!data || data.length < 10) return false;

    const partes = data.split("/");
    if (partes.length !== 3) return false;

    const [dia, mes, ano] = partes.map(Number);
    if (!dia || !mes || !ano) return false;

    const nascimento = new Date(ano, mes - 1, dia);

    if (
      nascimento.getDate() !== dia ||
      nascimento.getMonth() + 1 !== mes ||
      nascimento.getFullYear() !== ano
    ) {
      return false;
    }

    const hoje = new Date();
    let idade = hoje.getFullYear() - ano;

    if (
      hoje.getMonth() + 1 < mes ||
      (hoje.getMonth() + 1 === mes && hoje.getDate() < dia)
    ) {
      idade--;
    }

    return idade >= 18;
  }

  // ✅ Validação geral do formulário
  const isValid =
  String(data.nomeResponsavel || "").trim() !== "" &&
  validarNascimento(data.idade) &&
  String(data.telefone || "").trim().length >= 14 &&
  String(data.cpf || "").trim().length === 14;


  return (
    <>
      {/* --- SECTION (CABEÇALHO) --- */}
      <SectionCard
        title="Identificação do Responsável"
        description="Responda com atenção."
        items={[
          { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
        ]}
      />

      {/* --- BLOCO DE PERGUNTAS --- */}
      <div className="card-uniform mt-1">

        {/* Nome */}
        <div className="mb-3">
          <label className="form-label fw-bold">Nome do responsável *</label>
          <input
            type="text"
            className="form-control"
            value={data.nomeResponsavel}
            onChange={(e) => onChange({ nomeResponsavel: e.target.value })}
            required
          />
        </div>

        {/* ✅ Data de nascimento com máscara */}
        <div className="mb-3">
          <label className="form-label fw-bold">Data de nascimento *</label>
          <input
            type="text"
            className="form-control"
            value={data.idade}
            onChange={(e) =>
              onChange({ idade: maskDate(e.target.value) })
            }
            placeholder="DD/MM/AAAA"
            required
          />
          {!validarNascimento(data.idade) && data.idade.length === 10 && (
            <small className="text-danger">
              Você deve ser maior de 18 anos e informar uma data válida.
            </small>
          )}
        </div>

        {/* Telefone */}
        <div className="mb-3">
          <label className="form-label fw-bold">Telefone *</label>
          <input
            type="text"
            className="form-control"
            value={data.telefone}
            onChange={(e) => onChange({ telefone: maskPhone(e.target.value) })}
            placeholder="(00) 00000-0000"
            required
          />
        </div>

        {/* CPF */}
        <div className="mb-3">
          <label className="form-label fw-bold">CPF *</label>
          <input
            type="text"
            className="form-control"
            value={data.cpf}
            onChange={(e) => onChange({ cpf: maskCPF(e.target.value) })}
            placeholder="000.000.000-00"
            required
          />
        </div>
      </div>

      {/* BOTÃO */}
      <button
        className="btn btn-primary w-100 mt-2 mb-5"
        onClick={onNext}
        disabled={!isValid}
      >
        Próximo
      </button>
    </>
  );
}
